import { render, staticRenderFns } from "./OrderHoldByReservation.vue?vue&type=template&id=14440160&"
import script from "./OrderHoldByReservation.vue?vue&type=script&lang=ts&"
export * from "./OrderHoldByReservation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports